import React from 'react';
import { Icon } from '../../primitives/Icon';
import { FilterChipProps } from './index';
import './FilterDrawer.css';

const FilterChip: React.FC<FilterChipProps> = ({ label, onRemove, showRemoveButton = true }) => {
  // Si pas de bouton remove, le chip entier est cliquable
  if (!showRemoveButton) {
    return (
      <button className="filter-chip filter-chip--clickable" onClick={onRemove}>
        <span className="filter-chip-label">{label}</span>
      </button>
    );
  }

  return (
    <div className="filter-chip">
      <span className="filter-chip-label">{label}</span>
      <button
        className="filter-chip-remove"
        onClick={onRemove}
        aria-label="Supprimer le filtre"
      >
        <Icon name="X" size={14} />
      </button>
    </div>
  );
};

export default FilterChip;
